import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import { getFacilitiesSuccess, start } from "../../store/slices/FacilitiesSlice";
import { useEffect, useState } from "react";
import AddFacilityForm from "./AddFacilityForm";
import FacilitiesData from "./FacilitiesData";

export default function Facilities() {
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = useState(false);
  const [message, setMessage] = useState({});
  const userdetails = JSON.parse(localStorage.getItem("userdetails"));
  const [searchTerm, setSearchTerm] = useState("");

  const { data } = useFetch(
    localStorage.getItem("email") === "superadmin@mail.com"
      ? "facilities"
      : `facilities/GetAllFacilitiesByEmployeeLevel?employee_id=${
          userdetails && userdetails.id
        }`
  );

  const facilitiesData = useSelector((state) => state.facilities.data.facilitiesdata);

  useEffect(() => {
    if (data) {
      dispatch(getFacilitiesSuccess(data));
    } else {
      dispatch(start());
    }
  }, [data, dispatch]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // Filter the facilities data based on the search term
  const filteredData = facilitiesData?.results
    ? facilitiesData.results.filter((curData) => {
        const { name } = curData;
        return name?.toLowerCase().includes(searchTerm.toLowerCase());
      })
    : [];

  return (
    <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <h1 className="h2">Assets</h1>
        <div className="row">
          <div className="col-sm-5"></div>
          <div className="col-sm-2 mb-2">
            {message.success && <span className="success">{message.success}</span>}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 d-flex justify-content-end title-bg">
            
            <button
              className="btn btn-primary btn-add"
              onClick={() => setModalShow(true)}
            >
              <i className="fa-regular fa-square-plus"></i> ADD AN ASSET
            </button>
          </div>
          <AddFacilityForm
            show={modalShow}
            onHide={() => setModalShow(false)}
            setMessage={setMessage}
          />
        </div>
      </div>

      <nav>
        <div className="nav nav-tabs team-mngmt-tab" id="nav-tab" role="tablist">
          <button
            className="nav-link active"
            id="nav-facilities-tab"
            data-bs-toggle="tab"
            type="button"
            role="tab"
            aria-controls="nav-facilities"
          >
            <b>Assets</b>
          </button>
        </div>
        <div className="row">
          <div className="col-sm-4 position-relative">
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleSearchChange}
              className="form-control"
            />
            <span className="fa fa-search department-search-icon"></span>
          </div>
        </div>

        <div className="row">
          {/* Pass searchTerm and filteredData to FacilitiesData */}
          <FacilitiesData searchTerm={searchTerm} filteredData={filteredData} />
        </div>
      </nav>
    </main>
  );
}